import React from 'react'
import PropTypes from 'prop-types'
import {Box, Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import GiftCertificateItem from '../../components/gift-certificate-item'

/**
 * OrderGiftCards is a React component that renders a list of gift certificate items
 * associated with an order. It displays each gift certificate in a structured format.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.giftCertificateItems - An array of gift certificate items, each containing
 *                                             relevant details such as `giftCertificateItemId`.
 *
 * @returns {JSX.Element} A React fragment containing a list of gift certificate items
 *                        with their respective details.
 */
const OrderGiftCards = ({giftCertificateItems, conversionsRate, shipToCountryCode}) => {
    return (
        <Stack as="ul" gap={16}>
            {giftCertificateItems.map((gc) => (
                <Box
                    key={gc.giftCertificateItemId}
                    layerStyle="accountCard"
                    as="li"
                    listStyleType="none"
                >
                    <GiftCertificateItem
                        key={gc.giftCertificateItemId}
                        giftCertificateItem={gc}
                        conversionsRate={conversionsRate}
                        shipToCountryCode={shipToCountryCode}
                        imageStyles={{width: '85px'}}
                        headingStyles={{fontSize: '3xl'}}
                    />
                </Box>
            ))}
        </Stack>
    )
}

OrderGiftCards.propTypes = {
    giftCertificateItems: PropTypes.array.isRequired,
    conversionsRate: PropTypes.object.isRequired,
    shipToCountryCode: PropTypes.string.isRequired
}

export default OrderGiftCards
